import React, { useState, useEffect, useContext } from 'react';
import { Form, Radio, Button } from 'antd';
import Typing from '../Typing/Typing';
import CmpsAnimation from '../CmpsAnimation/CmpsAnimation';
import Timestamp from '../../components/Timestamp/Timestamp';
import * as Api from '../../services/api';
import { Context } from '../../ChatContext';
import CmpsMsgStatus from '../CmpsMsgStatus/CmpsMsgStatus';
import CmpsNotValid from '../CmpsNotValid/CmpsNotValid';
import * as Utils from '../../services/utils';

function CmpsFilial({onComplete, onScroll, form, onError, onShowInput, onReset}) {
  const [typing, setTyping] = useState(true);
  const [msg, setMsg] = useState(false);
  const [context, setContext] = useContext(Context);
  const [listaFiliali, setListaFiliali] = useState(false);
  const [itemsToShow, setItemsToShow] = useState(2);

  const onChange = (e) => {
    Utils.eventsDataLayer('customPageview', '/chatbot-fissa-appuntamento/scelta-filiale');
    setMsg(form.getFieldValue("filiale").nomeFiliale);
    onComplete('step4');
  }

  const showMoreLess = () => {
    if (itemsToShow + 2 <= listaFiliali.length) {
      setItemsToShow(itemsToShow + 2);
    } else {
      setItemsToShow(2);
    }
    setTimeout(() => {
      onScroll();
    });
  }

  const reset = () => {
    onReset();
  }

  useEffect(() => {
    onShowInput(false);
    Api.getElencoFiliali({
      Coordinate : {
        lat: context.coordinates.lat,
        lng: context.coordinates.lon
      }      
    }).then(function (response) {
      setListaFiliali(response.data);
      if(response.timings && response.timings.elapsedTime) {
        if(response.timings.elapsedTime <= 2000) {
          setTimeout(() => {
            setTyping(false);
            onScroll();
          }, 2000);
        } else {
          setTyping(false);
          onScroll();
        }
      } else {
        setTyping(false);
        onScroll();
      }
    })
    .catch(function (error) {
      console.log(error);
      onError();
    });
  }, []);

  return (
    <section id="filial">
      {typing && <Typing wait={1200} />}
      {!typing && (
        <div className="messages messages--receiver">
          <div className="message">
            <CmpsAnimation wait={300} last={listaFiliali.length > 0 ? true : false}>
              <span className="bubble">Perfetto! A quale filiale preferisci<br /> rivolgerti?</span>
            </CmpsAnimation>
            {listaFiliali.length <= 0 && (
              <>
                <CmpsNotValid msg="Non ci sono filiali disponibili per il giorno selezionato. Ti consigliamo di procedere con una nuova richiesta provando una combinazione differente." />
                <CmpsAnimation wait={2200}>
                  <Button className={['cmps_btn', 'cmps_btn__redirect']} onClick={reset}>RICOMINCIA!</Button>
                </CmpsAnimation>
              </>
            )}
            {(!msg && listaFiliali.length > 0) && (
              <CmpsAnimation wait={600}>
                  <Form.Item className={`cmps_radio_button`} name="filiale">
                    <Radio.Group onChange={onChange}>
                      {listaFiliali.slice(0, itemsToShow).map((filiale, index) =>
                        <Radio.Button key={filiale.idFiliale} value={filiale}>
                          {filiale.nomeFiliale}
                          <span className="subtitle">{filiale.indirizzo}</span>
                        </Radio.Button>
                      )}
                    </Radio.Group>
                  </Form.Item>
                  <p className={`show_more`} onClick={showMoreLess}>
                    {itemsToShow===10 ? 'Mostra meno filiali' : 'Mostra altre filiali'}
                  </p>
                  <div className="info">
                    <span className="time"><Timestamp /></span>
                  </div>
              </CmpsAnimation>
            )}
          </div>
        </div>
      )}
      {msg && (
        <div className="messages messages--sender">
          <CmpsAnimation wait={300}>
            <div className="message">
              <span className="bubble">{msg}</span>
            </div>
            <div className="info">
              <span className="time"><Timestamp /></span>
              <CmpsMsgStatus />
            </div>
          </CmpsAnimation>
        </div>
      )}
    </section>
  );
} 

export default CmpsFilial;
